import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchKickMessage = async () => {
    const { data } = await internalApi.get('server_info/kickMessage');
    return data.rows;
}

export const useKickMessage = () => {
    return useQueryBase('kickMessage', fetchKickMessage);
}

const updateKickMessage = async (kickMessages) => {
    await internalApi.post('server_info/kickMessage', { ...kickMessages });
    return kickMessages;
};

export const useUpdateKickMessage = () => {
    return useMutationBase('kickMessage', updateKickMessage);
}

const deleteKickMessage = async (index) => {
    await internalApi.delete(`server_info/kickMessage?index=${index}`);
    return index;
}

export const useDeleteKickMessage = () => {
    return useMutationBase('kickMessage', deleteKickMessage);
}